import { Modal } from 'antd'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { translate } from '../languages'
import { RootState } from '../stores'
import {
  setAlert,
  setShowManageModal,
  setShowPayInModal,
  setShowResetPasswordModal,
} from '../stores/actions'

type ManageModalComponentProps = {
  body: React.ReactNode
  title?: string
  width?: string
}

export const ManageModalComponent: React.FC<ManageModalComponentProps> = ({
  body,
  title,
  width,
}) => {
  const dispatch = useDispatch()
  const location = useLocation()
  const { language } = useSelector((state: RootState) => state.language)
  const { management } = useSelector((state: RootState) => state.common)

  return (
    <Modal
      title={
        title ||
        `${translate(
          `common.${management.action.toLowerCase()}.detail`,
          language
        )} ${translate(
          `api.name.${location.pathname.replace(/\//, '')}`,
          language
        )}`
      }
      visible={true}
      onCancel={() => {
        dispatch(setShowManageModal(false))
        dispatch(setShowResetPasswordModal(false))
        dispatch(setShowPayInModal(false))
        dispatch(setAlert())
      }}
      closable={!management.actionProcessing}
      footer={false}
      style={{ top: 20 }}
      width={width}
    >
      {body}
    </Modal>
  )
}
